import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';

const expectedProgressBaseCol = (gantt, t) => ({
  name: 'expected_progress_base',
  label: 'Esperado Base',
  align: 'center',
  resize: true,
  width: '*',
  template: (activity) => {
    const hasChild = gantt.hasChild(activity.id);
    let isOdd = false;
    if (gantt.oddColsConfig) {
      isOdd = gantt.oddColsConfig.expected_progress_base;
    }
    if (
      activity.expected_progress_base ||
      activity.expected_progress_base == 0
    ) {
      if (activity.expected_progress_base.toFixed) {
        return t('lang') === 'en'
          ? '<div class="' +
              (isOdd ? 'odd-col' : 'non-odd-col') +
              '" style="' +
              (hasChild ? 'font-weight: 600' : 'font-weight: 100') +
              '">' +
              activity.expected_progress_base.toFixed(2) +
              '%</div>'
          : '<div class="' +
              (isOdd ? 'odd-col' : 'non-odd-col') +
              '" style="' +
              (hasChild ? 'font-weight: 600' : 'font-weight: 100') +
              '">' +
              activity.expected_progress_base.toFixed(2).replace('.', ',') +
              '%</div>';
      }
    } else {
      return (
        '<div class="' +
        (isOdd ? 'odd-col' : 'non-odd-col') +
        '" style="' +
        (hasChild ? 'font-weight: 600' : 'font-weight: 100') +
        '">-%</div>'
      );
    }
    return '';
  },
  hide: !isColumnVisibleByDefault('expected_progress_base'),
  data_type: 'number',
  groupable: false,
  orderable: true,
  orderable_switch: ['1 → 9', '9 → 1'],
  filterable: true
});

export default expectedProgressBaseCol;